import { createAsyncThunk } from '@reduxjs/toolkit'
import _ from 'lodash'
import { sendAsync } from '../../../app/applicationSlice'
import { RootThunkApi } from '../../../app/store'
import {
  AcceptParams,
  BaseSubmitParams,
  getAccept,
  getAddFirstBussiness,
  getDetail,
  getFirstsellrecordBaseSubmit,
  getVarietyManagementDelete,
  getVarietyManagementList,
  getVarietyManagementListExport,
  varietyManagementListParams,
} from '../../../services/firstTimeBusinessManagement'


// 首营品种管理列表
export const getVarietyManagementListAsync = createAsyncThunk<
  void,
  varietyManagementListParams,
  RootThunkApi<void>
>('VarietyManagement/getVarietyManagementListAsync', async (params, api) => {
  return sendAsync(getVarietyManagementList(params), api)
})

// 新增首营品种登记表
export const getAddFirstBussinessAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>('VarietyManagement/getAddFirstBussinessAsync', async (params, api) => {
  return sendAsync(getAddFirstBussiness(params), api)
})

// 详情
export const getDetailAsync = createAsyncThunk<void, any, RootThunkApi<void>>(
  'VarietyManagement/getDetailAsync',
  async (params, api) => {
    return sendAsync(getDetail(params), api)
  }
)

// 审批
export const getAcceptAsync = createAsyncThunk<
  void,
  AcceptParams,
  RootThunkApi<void>
>('VarietyManagement/getAcceptAsync', async (params, api) => {
  return sendAsync(getAccept(params), api)
})

// 保存
export const getFirstsellrecordBaseSubmitAsync = createAsyncThunk<
  void,
  BaseSubmitParams,
  RootThunkApi<void>
>(
  'VarietyManagement/getFirstsellrecordBaseSubmitAsync',
  async (params, api) => {
    return sendAsync(getFirstsellrecordBaseSubmit(params), api)
  }
)

//导出
export const getVarietyManagementListExportAsync = createAsyncThunk<
  void,
  varietyManagementListParams,
  RootThunkApi
>('VarietyManagement/getVarietyManagementListExportAsync ', async (params, api) => {
  return sendAsync(getVarietyManagementListExport(params), api)
})


// 删除
export const getVarietyManagementDeleteAsync = createAsyncThunk<
  void,
  any,
  RootThunkApi<void>
>(
  'VarietyManagement/getVarietyManagementDeleteAsync',
  async (params, api) => {
    return sendAsync(getVarietyManagementDelete(params), api)
  }
)
